import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

export const fetchAdmins = createAsyncThunk(
  'admins/fetchAdmins',
  async (params, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const clubId = state.club?.club?.id;

      if (!clubId) {
        return rejectWithValue('Club ID not found');
      }

      const { page, limit, searchValue, sortBy, sortOrder } = params;

      const queryParams = new URLSearchParams();
      if (page) queryParams.append('page', page);
      if (limit) queryParams.append('limit', limit);
      if (searchValue) queryParams.append('searchValue', searchValue);
      if (sortBy) queryParams.append('sortBy', sortBy);
      if (sortOrder) queryParams.append('sortOrder', sortOrder);

      const { data } = await api.get(
        `/admins/club/${clubId}?${queryParams.toString()}`
      );

      return data;
    } catch (err) {
      console.error(
        'Error fetching admins:',
        err.response?.data || err.message
      );
      return rejectWithValue(err.response?.data?.message || 'Request error');
    }
  }
);

const initialState = {
  admins: [],
  isLoadingAdmins: false,
  errorAdmins: null,
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 1,
  },
};

const adminsSlice = createSlice({
  name: 'admins',
  initialState,
  reducers: {
    addAdmin(state, action) {
      state.admins.push(action.payload);
    },
    editAdmin(state, action) {
      const { id, ...updatedFields } = action.payload;
      const admin = state.admins.find((admin) => admin.id === id);
      if (admin) {
        Object.assign(admin, updatedFields);
      }
    },
    deleteAdmin(state, action) {
      state.admins = state.admins.filter(
        (admin) => admin.id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAdmins.pending, (state) => {
      state.isLoadingAdmins = true;
      state.errorAdmins = null;
    });

    builder.addCase(fetchAdmins.fulfilled, (state, action) => {
      state.admins = action.payload.data;
      state.pagination = action.payload.pagination;
      state.isLoadingAdmins = false;
    });

    builder.addCase(fetchAdmins.rejected, (state, action) => {
      state.isLoadingAdmins = false;
      state.errorAdmins = action.payload || 'Something went wrong...';
    });
  },
});

export const { addAdmin, editAdmin, deleteAdmin } = adminsSlice.actions;

export default adminsSlice.reducer;
